"use client"

type AuctionBidCustomAmountFieldProps = {
  currencySym: string
  value: string
  onChange: (next: string) => void
  focused: boolean
  onFocus: () => void
  onBlur: () => void
}

export function AuctionBidCustomAmountField({
  currencySym,
  value,
  onChange,
  focused,
  onFocus,
  onBlur,
}: AuctionBidCustomAmountFieldProps) {
  return (
    <div
      className={`relative flex-1 min-w-20 max-w-24 rounded-full border transition-colors ${
        focused || value ? "border-foreground/40 ring-2 ring-ring/50" : "border-border"
      }`}
    >
      <span
        className={`absolute left-3 top-1/2 -translate-y-1/2 text-sm pointer-events-none transition-colors ${
          focused || value ? "text-foreground" : "text-muted-foreground"
        }`}
      >
        +{currencySym}
      </span>
      <input
        type="text"
        inputMode="numeric"
        placeholder="..."
        className="w-full pl-7 pr-3 py-2 rounded-full bg-muted border-0 text-base md:text-sm font-mono text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-0"
        value={value}
        onChange={(e) => {
          const v = e.target.value
          if (v === "" || /^\d+$/.test(v)) onChange(v)
        }}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  )
}
